import script from "./PlatIcons.vue?vue&type=script&lang=ts&setup=true"
export * from "./PlatIcons.vue?vue&type=script&lang=ts&setup=true"

import "./PlatIcons.vue?vue&type=style&index=0&id=4ecef404&lang=scss&scoped=true"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4ecef404"]])

export default __exports__